import type { Memory, MemoryAction, MemoryState } from "../../api/threads/memoriesApi";

/** The catalogue's views, in the order of their tabs (memory.md MEM-7). */
export const CATALOGUE_STATES: readonly MemoryState[] = ["active", "proposed", "stale", "retired"];

/**
 * The actions a person may take on a memory: those its state allows (the server's state
 * machine, MEM-5) and the caller may take. Deleting is separate: any state, same right as
 * retiring.
 */
export function memoryActions(memory: Memory): readonly MemoryAction[] {
  switch (memory.state) {
    case "proposed":
      return memory.mayConfirm ? ["confirm", "discard"] : [];
    case "active":
      return memory.mayChange ? ["retire"] : [];
    case "stale":
      return memory.mayChange ? ["keep", "retire"] : [];
    case "retired":
      return memory.mayChange ? ["restore"] : [];
    case "discarded":
      return [];
  }
}

/**
 * Whether a reference card (a Thread's "kept from here", "My memories") leaves a proposed
 * memory to its own Thread (OW-07): it shows it and links there, and doesn't word or decide it.
 * In its own Thread the waiting review step decides; with no step waiting there, the Thread's
 * own card does (`memoryUnderReview`), so one place to decide always remains.
 */
export function deferredToItsThread(memory: Memory): boolean {
  return memory.state === "proposed" && memory.keptIn !== null;
}

/** The first characters of a passage, for a catalogue row. */
export function passagePreview(text: string, limit = 200): string {
  return text.length <= limit ? text : `${text.slice(0, limit - 1).trimEnd()}…`;
}
